import {
    MAX_COMMENT_LENGTH,
    MAX_RATING_VALUE,
    MIN_RATING_VALUE,
    RATING_SETTINGS,
    RATING_NAMES_BUYER,
    RATING_NAMES_SELLER,
    UNSET_RATING_VALUE
} from './constants';

export const togglePositive = (previous, isPositive) => {
    let result;
    if (previous === null) {
        result = isPositive;
    } else {
        result = previous === isPositive ? null : isPositive;
    }
    return result;
};

export const createFeedbackPayload = (
    itemId,
    memberId,
    transactionId,
    ratingNames
) => {
    const ratings = {};
    ratingNames.forEach(name => {
        // eslint-disable-next-line better-mutation/no-mutation
        ratings[name] = MAX_RATING_VALUE;
    });
    return {
        comment: '',
        ratings,
        inr: false,
        transactionId: transactionId,
        isPositive: null,
        itemId: itemId,
        memberId: memberId
    };
};

export const createFeedbackPayloadsMap = (groups, isBuyer) => {
    const ratingNames = isBuyer ? RATING_NAMES_BUYER : RATING_NAMES_SELLER;
    const feedbacks = {};
    groups.map(group => {
        group.items.map(item => {
            const feedback = createFeedbackPayload(
                item.itemId,
                item.memberId,
                item.transactionId,
                ratingNames
            );
            // eslint-disable-next-line better-mutation/no-mutation
            feedbacks[item.transactionId] = feedback;
        });
    });
    return feedbacks;
};

export const getRatingSettings = isBuyer => {
    const ratingNames = isBuyer ? RATING_NAMES_BUYER : RATING_NAMES_SELLER;
    return ratingNames.map(ratingName => RATING_SETTINGS[ratingName]);
};

export const isCommentTooLong = comment =>
    comment.trim().length > MAX_COMMENT_LENGTH;
export const isCommentWithLinebreaks = comment => !!comment.match(/\r|\n/);
export const isPositiveOrNegative = feedback => feedback.isPositive !== null;
export const isAllRatingsValid = feedback =>
    Object.values(feedback.ratings).every(
        value => value === UNSET_RATING_VALUE || value >= MIN_RATING_VALUE
    );

export const isValidFeedback = feedback =>
    isAllRatingsValid(feedback) &&
    !isCommentTooLong(feedback.comment) &&
    !isCommentWithLinebreaks(feedback.comment) &&
    isPositiveOrNegative(feedback);

export const getValidationErrorTranslationKeys = feedback => {
    const result = [];
    if (isCommentWithLinebreaks(feedback.comment)) {
        result.push('leaveFeedback_noLineBreaks');
    }
    return result;
};
